/* Association editing functionality */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ILocationModel {
    address1: string;
    address2: string;
    city: string;
    stateCode: string;
    postalCode: string;
    countryCode: string;
}

export interface IAssociationModel {
    name: string;
    location: ILocationModel;
}

export interface IAssociationEditState {
    isEditMode: boolean;
    formData: IAssociationModel;
    formErrors: any;
}

const initialState: IAssociationEditState = {
    isEditMode: false,
    formData: {
        name: '',
        location: {
            address1: '',
            address2: '',
            city: '',
            stateCode: '',
            postalCode: '',
            countryCode: '',
        },
    },
    formErrors: {}
};

export function editAssociationReducer(state: IAssociationEditState = initialState, action: any): IAssociationEditState {
    switch (action.type) {
        case Actions.TOGGLE_EDITMODE_FOR_ASSOCIATION:
            return _.merge({}, state, { isEditMode: action.value });
        case Actions.ASSOCIATION_EDIT_FORM_UPDATE:
            let x = _.merge(
                {},
                state,
                {
                    formData: Object.assign({}, action.data || {}),
                    formErrors: Object.assign({}, action.errors || {}),
                }
            );

            // console.log('editAssociationReducer Actions.ASSOCIATION_EDIT_FORM_UPDATE merge', x);

            return x;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/editAssociationReducer.tsx